import { TransfertActionState } from "@/models/transferActions";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const transfertActionState: TransfertActionState = {
  addWallet: false,
  feedBank: false,
  withdrawBank: false,
  cryptoToBank: false,
  bankToCrypto: false,
  kypayOnChainDetails: false,
  transfer: false,
  authenticationRequireHelper: false,
  confirmationCreationWallet: false,
  createAccount: false,
  readMore: false,
  kyc: false
};

export const transfertActionSlice = createSlice({
  name: "transferActions",
  initialState: transfertActionState,

  reducers: {
    setAddWallet: (state, action: PayloadAction<boolean>) => {
      state.addWallet = action.payload;
    },
    setFeedBank: (state, action: PayloadAction<boolean>) => {
      state.feedBank = action.payload;
    },
    setWithdrawBank: (state, action: PayloadAction<boolean>) => {
      state.withdrawBank = action.payload;
    },
    setCryptoToBank: (state, action: PayloadAction<boolean>) => {
      state.cryptoToBank = action.payload;
    },
    setBankToCrypto: (state, action: PayloadAction<boolean>) => {
      state.bankToCrypto = action.payload;
    },
    setKypayOnChainDetails: (state, action: PayloadAction<boolean>) => {
      state.kypayOnChainDetails = action.payload;
    },
    setTransfer: (state, action: PayloadAction<boolean>) => {
      state.transfer = action.payload;
    },
    setAuthenticationRequireHelper: (state, action: PayloadAction<boolean>) => {
      state.authenticationRequireHelper = action.payload;
    },
    setConfirmationCreateWallet: (state, action: PayloadAction<boolean>) => {
      state.confirmationCreationWallet = action.payload;
    },
    setCreateAccount: (state, action: PayloadAction<boolean>) => {
      state.createAccount = action.payload;
    },
    setReadMore: (state, action: PayloadAction<boolean>) => {
      state.readMore = action.payload;
    },
    setKyc: (state, action: PayloadAction<boolean>) => {
      state.kyc = action.payload;
    },
    resetState: () => transfertActionState
  },
  selectors: {
    getTransferAction: (state): TransfertActionState => ({ ...state })
  }
});

export const {
  setAddWallet,
  setAuthenticationRequireHelper,
  setBankToCrypto,
  setCryptoToBank,
  resetState,
  setFeedBank,
  setKypayOnChainDetails,
  setTransfer,
  setWithdrawBank,
  setConfirmationCreateWallet,
  setCreateAccount,
  setKyc,
  setReadMore
} = transfertActionSlice.actions;

export const { getTransferAction } = transfertActionSlice.selectors;
